import { t } from '@lingui/macro';

import { Page, PageHeader, FilterContainer, PanelContainer } from '../../page-framework';
import { TimeRangeFilter, AlertCategoryFilter, SeverityFilter, AlertStateFilter } from '../../filters';
import { AlertListPanel } from '../../panels';

export const pageId = 'alerts';

export default function AlertsPage() {
    return (
        <Page id={pageId}>
            <PageHeader title={t`Alerts`}>
                <FilterContainer>
                    <TimeRangeFilter required />
                    <AlertCategoryFilter />
                    <SeverityFilter />
                    <AlertStateFilter />
                </FilterContainer>
            </PageHeader>
            <PanelContainer>
                <AlertListPanel hideTitle flexHeight />
            </PanelContainer>
        </Page>
    );
}
